import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "profile",
  "use": "profile-usage",
  "viewBox": "0 0 16.688 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.688 18\" id=\"profile\">\n  <path fill-rule=\"evenodd\" d=\"M47.994,409.9A7.157,7.157,0,0,0,49,406.187C49,402.77,46.761,400,44,400s-5,2.77-5,6.187a7.156,7.156,0,0,0,1.006,3.712,7.232,7.232,0,0,0-4.34,6.413v0.563A1.118,1.118,0,0,0,36.778,418H51.222a1.118,1.118,0,0,0,1.111-1.125v-0.563A7.232,7.232,0,0,0,47.994,409.9ZM44,401.687c1.807,0,3.333,2.061,3.333,4.5s-1.527,4.5-3.333,4.5-3.333-2.061-3.333-4.5S42.193,401.687,44,401.687Zm-6.667,14.625a5.644,5.644,0,0,1,3.789-5.07,4.221,4.221,0,0,0,5.755,0,5.644,5.644,0,0,1,3.789,5.07H37.333Z\" transform=\"translate(-35.656 -400)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/profile.svg
// module id = null
// module chunks = 